import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'software-version-detail-legacy-redirect',
	path: '/browse/:projectKey/fixforversion/:versionId',
};
